/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Manager가 스프린트에서 일을 하기 위해 계약을 해야 하는데 그 계약의 진행상태
 */
export type ManagerContractStatusType = 'Pending' | 'Completed';

export const ManagerContractStatusType = {
    Pending: 'Pending' as ManagerContractStatusType,
    Completed: 'Completed' as ManagerContractStatusType
};

